import { useEffect, useState, useMemo } from 'react';
import Card from '../components/card/Card';
import Button from '../components/button/Button';
import H from '../components/texts/h/H';
import P from '../components/texts/p/P';
import Icon from '../components/icon/Icon';
import { getApplicationResume } from '../services/ApplicationService';
import { hasData } from '../utils/Utils';
import { useNavigate } from 'react-router-dom';
import Tooltip from '../components/tooltip/Tooltip';
type SpacingType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11';

type iconType ={
  name:string,
  height:number,
  width:number,
  msg:string
}




const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};



 

const Dashboard = () => {
  
 const windowWidth = useWindowSize();

  const [pendingMargin, setPendingTitleType] = useState<| SpacingType
    | {
        top?: SpacingType;
        left?: SpacingType;
        right?: SpacingType;
        bottom?: SpacingType;
      }
    | string>(
    windowWidth > 1850 ? {left:'3'} : {left:'5', right:'5'}
  );
  const name = localStorage.getItem('full_name');
  const config = JSON.parse(localStorage.getItem('config') ?? '{}');
  const isInstrumentationEnabled = config?.isInstrumentationEnabled ?? true;
  const [sections, setSections] = useState([]);
  const navigate = useNavigate();



 const [displayFlex, setDisplayFlex] = useState(
    windowWidth > 1850 ? 'flex' : 'block'
  );
  const [isMobile, setIsmobile] = useState(
    windowWidth > 1500 ? false : true
  );

   const iconMaps: Map<string, iconType> = new Map([
  ['REV', {
    name:'origination_outline',
    height: isMobile?42:28,
    width: isMobile?42:28,
    msg: 'Originacion'
  }],
  ['APP', {
    name:'risk_outline',
    height: isMobile?42:28,
    width: isMobile?42:28,
    msg: 'Análisis de Riesgo'}],
  ['COM', {name:'committee_outline',
    height: isMobile?42:28,
    width: isMobile?42:28,
    msg: 'Comité'
  }],
  ['INS', {name:'instrumentation_outline',
    height: isMobile?46:42,
    width: isMobile?46:42,
    msg: 'Instrumentación'
  }],
]);
const getIconName = (code: string): string => {
  return iconMaps.get(code)?.name || '';  
}
const getIconHeight = (code: string): number => {
  return iconMaps.get(code)?.height || 28;
}
const getIconWidth = (code: string): number => {
  return iconMaps.get(code)?.width || 28;
}

const renderIcon = (section:any) =>{
  return (
    <Icon name={getIconName(section.code)} variant='info' height={getIconHeight(section.code)}  width={getIconWidth(section.code)}/>
  )
}



const getIconMsg = (code: string): string => {
  return iconMaps.get(code)?.msg || '';
}
const routesMaps: Map<string, string> = new Map([
  ['REV', '/inicio'],
  ['APP', '/analisisderiesgo'],
  ['COM', '/comite'],
  ['INS', '/instrumentacion'],
]);

const labelMaps: Map<string, string> = new Map([
  ['REV', 'Originación'],
  ['APP', 'Análisis de Riesgo'],
  ['COM', 'Comité'],
  ['INS', 'Instrumentación'],
])
  
  

  useEffect(() => {
    fetchDashboardData();
  }, []);

  useEffect(() => {
      setDisplayFlex(windowWidth > 1850 ? 'flex' : 'block');
      setPendingTitleType( windowWidth > 1850 ? {left:'3'} : {left:'5', right:'5'})
      setIsmobile(windowWidth > 1500 ? false : true);

    }, [windowWidth]);

  const fetchDashboardData = async () => {
    getApplicationResume().then((response) => {
      if (hasData(response)) setSections(response.data);
    });
  };

  const filteredSections = useMemo(() => {
    if (!Array.isArray(sections)) return [];
    return sections.filter(section => isInstrumentationEnabled || section.code !== 'INS');
  }, [sections, isInstrumentationEnabled]);

  const cardWidth = useMemo(() => {
    return filteredSections.length > 0 ? `${100 / filteredSections.length}%` : '25%';
  }, [filteredSections]);

  return (
    <Card
      variant='neutral'
      modifier='inverted'
      spacing={'4'}
      height='-webkit-fill-available'
      width='85vw'
    >
      <Card display='flex' justifyContent='space-between' alignItems='center'>
        <Card display='flex' gap='16px' alignItems='center'>
          <H type='1' weight='bold' modifier='strong'>
            Hola, {name}
          </H>
        </Card>
        <Button
          variant='primary'
          size='lg'
          onClick={() => navigate('/clientes')}
        >
          Nueva solicitud
        </Button>
      </Card>

      <Card display='flex' gap='16px' margin={{ top: '4' }}>
        {filteredSections.map((section) => (
          <Card
            key={section.code}
            modifier='weak'
            spacing='4'
            width={cardWidth}
            onClick={() => navigate(routesMaps.get(section.code))}
          >
            <Card
              display='flex'
              gap='8px'
              alignItems='center'
              justifyContent='center'
              variant='neutral'
              modifier='regular'
            >
             
                <Card  margin={isMobile?{top:'2',bottom:'2'}:{top:'0',bottom:'0'}} >
                   {isMobile?<Tooltip position='top' msg={getIconMsg(section.code)}>
                    
                    {renderIcon(section)}
                   </Tooltip>:renderIcon(section)}
                </Card>
             
              {
                !isMobile &&<P type='3' variant='neutral' weight='bold'>
                {labelMaps.get(section.code)}
              </P>
              }
              
            </Card>
            <Card
              display={displayFlex}
              margin={{ top: '1' }}
              
              alignItems='center'
              variant='neutral'
              modifier='regular'
              onClick={() => navigate(routesMaps.get(section.code))}
            >
              <Card margin={{ left: '3' }} display='flex' justifyContent='center' alignItems='center'>
                <H type= '0' weight='bold' variant='info'>
                  {section.pending}
                </H>
              </Card>
              <Card margin={pendingMargin} display='flex' justifyContent='center' alignItems='center'>
                <H type='2' weight='bold'>
                  Solicitudes pendientes
                </H>
              </Card>
            </Card>
          </Card>
        ))}
      </Card>
    </Card>
  );
};

export default Dashboard;
